<div *ngIf="displayTicketDistribution" id="app-heat-map-chart-section" class="app-heat-map-chart-section" style="height: 100%; width: 100%;"></div>
<div *ngIf="!displayTicketDistribution" style="text-align: center; margin-top: 100px;">No data present for ticket
    distribution.</div>